import { render, staticRenderFns } from "./addPlkp.vue?vue&type=template&id=f5c6f660&scoped=true&"
import script from "./addPlkp.vue?vue&type=script&lang=js&"
export * from "./addPlkp.vue?vue&type=script&lang=js&"
import style0 from "./addPlkp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addPlkp.vue?vue&type=style&index=1&id=f5c6f660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c6f660",
  null
  
)

export default component.exports